export type SelectOption = {
	value: string;
	label: string;
	isDisabled?: boolean;
};

export enum SortOrder {
	ascending = 'ascending',
	descending = 'descending',
}

export type SortOrderOption = {
	value: SortOrder;
	label: string;
};

export type SelectProp = {
	label: string;
	options: SelectOption[];
	defaultOption: string;
	orderLabels?: {
		ascending: string;
		descending: string;
	};
	defaultOrder?: SortOrder;
	onSelect: (selectedOptionValue: string, order: SortOrder) => void;
};
